import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import "../Purchase/Purchase.css";
import { Navbar } from "../Common/Navbar/Navbar";
import { Footer } from "../Common/Footer/Footer";
import { Accordian } from "../Common/Accordian";
import BlackDollor from "../../Images/BundlDetail/blackdollor.svg";
import BlackTime from "../../Images/BundlDetail/blacktime.svg";
import greenIcon from "../../Images/green staked coin.svg";
import pinkIcon from "../../Images/pink staked coin.svg";
import blueIcon from "../../Images/blue staked coin.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { base_url } from "../Auth/BackendAPIUrl";
import { ConfigToken } from "../Auth/ConfigToken";
// import { ToastContainer } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Bgloader } from "../Common/Background/Bgloader";
import { Popup } from "../Common/Popup/Popup";
import { amountDecimal } from "../Utils/amountDecimal";
import toast, { Toaster } from "react-hot-toast";
import { processArabicText } from "../Utils/arabicFontParenthesisChecker";
import { convertBundlEnglishToRoute, isBrandIdentityOrder } from "./bundlRouteUtils";

let newToastId = null;

export const BundlDetail = ({ user, lang, setLang }) => {
  const location = useLocation();
  const { state } = location;
  const { packageID } = useParams();
  const [packageDetail, setPackageDetail] = useState([]);
  const navigate = useNavigate();
  const [brandError, setBrandError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [bundlAddons, setBundlAddons] = useState([]);
  const [minError, setMinError] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [addonPayLoads, setAddonPayLoads] = useState({});
  const [extraQty, setExtraQty] = useState({});
  const isSubmitting = useRef(false);
  const [brandInput, setBrandInput] = useState("");
  const [isSameBundl, setIsSameBundl] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [selectedIllustrations, setSelectedIllustrations] = useState("");
  const [firstOrder, setFirstOrder] = useState(true);
  const [actual, setactual] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isFromLogin, setIsFromLogin] = useState(state?.fromLogin);
  const requiredToastShown = useRef(false);
  const activeToasts = useRef({});
  const isInitialMount = useRef(true);
  const isLoadingFromStorage = useRef(false);
  const hasLoadedFromStorage = useRef(false);
  const isClearingCart = useRef(false);
  const [routeId, setRouteId] = useState({
    newbie: 12,
    foodie: 4,
    socialite: 22,
    boutiquer: 13,
  });
  const [routeNames, setRouteNames] = useState({
    4: "foodie",
    12: "newbie",
    13: "boutiquer",
    22: "socialite",
  });

  const [addOnLang, setAddOnLang] = useState([
    { id: 1, language: "English", label: "English", isChecked: true },
    { id: 2, language: "Arabic", label: "Arabic", isChecked: false },
    { id: 3, language: "both", label: "Both (+2,000 SAR)", isChecked: false },
  ]);

  const [coinIcon, setCoinIcon] = useState(greenIcon);
  const [textColor, setTextColor] = useState("#1BA56F");
  const [showDetails, setDetails] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 440);
  const [openPopup, setOpenPopup] = useState(false);
  const selectedItems = bundlAddons.bundle_details?.flatMap((bundle) =>
    bundle.design_list.map((design) => ({
      ...design,
      quantity: quantities[design.name_english] || design.quantity,
      total_price: design.total_price,
      total_time: (quantities[design.name_english] || 1) * design.time,
    }))
  );

  const handleAddOnChange = (id, language) => {
    setAddOnLang((prev) =>
      prev.map((ele) =>
        ele.id === id && ele.language === language
          ? { ...ele, isChecked: true }
          : { ...ele, isChecked: false }
      )
    );
  };

  const toastErrorMessage = (msg) => {
    const message = msg;

    if (newToastId) {
      toast.dismiss(newToastId);
    }

    newToastId = toast(message, {
      duration: 3000,
      style: {
        color: "#f175ad",
        border: `1px solid #f175ad`,
        fontWeight: "700",
        background: "#fff",
        boxShadow: "none",
        borderRadius: "0px",
      },
    });
  };

  useEffect(() => {
    getBundlData();
    // getprojects();
  }, []);

  useEffect(() => {
    if (user?.is_active) {
      // getprojects();
    }
  }, [user]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 440);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleRadioChange = (e) => {
    setSelectedLanguage(e.target.value);
  };

  const validateFields = async () => {
    const isToast = await getprojects();
    if (isToast === false) {
      return false;
    }

    if (brandInput === undefined || brandInput?.trim() == "") {
      if (!activeToasts.current["required-value-toast"]) {
        activeToasts.current["required-value-toast"] = true;
        setBrandError(true);
        setTimeout(() => {
          activeToasts.current["required-value-toast"] = false;
        }, 3000);
      }

      setBrandError(true);
      return false;
    }

    return true;
  };
  // Load data from cart API (always called if user is logged in)
  // This ensures localStorage is synced with API (API is source of truth)
  const loadDataFromCartAPI = async (bundleDetails) => {
    try {
      const tokenConfig = ConfigToken();
      const isAuthenticated =
        tokenConfig.headers?.authorization &&
        tokenConfig.headers.authorization !== "Token null";

      if (!isAuthenticated) {
        return false;
      }

      const cartResponse = await axios.get(
        `${base_url}/api/order/cart/`,
        ConfigToken()
      );

      const cartData = cartResponse?.data;

      // Check if cart has data and bundle_id matches current package
      if (
        !cartData ||
        !cartData.order_status ||
        cartData.order_status !== "in_cart"
      ) {
        console.log("Cart API: No valid cart data or order_status not in_cart", cartData);
        return false;
      }

      // Check bundle_id match
      if (cartData.bundle_id !== routeId[packageID]) {
        console.log("Cart API: Bundle ID mismatch", {
          cartBundleId: cartData.bundle_id,
          currentPackageId: routeId[packageID],
          packageID
        });
        return false;
      }

      console.log("Cart API: Loading data from cart (updating localStorage)", cartData);

      isLoadingFromStorage.current = true;
      let hasRestoredData = false;

      // Set isSameBundl to true so Accordian component will load addons
      setIsSameBundl(true);
      hasLoadedFromStorage.current = true;

      // Restore brand input
      if (cartData.project_name) {
        setBrandInput(cartData.project_name);
        hasRestoredData = true;
      }

      // Restore language selection
      if (cartData.language) {
        // Capitalize language to match radio button values
        const capitalizedLanguage = cartData.language.charAt(0).toUpperCase() + cartData.language.slice(1).toLowerCase();
        setSelectedLanguage(capitalizedLanguage);
        hasRestoredData = true;
      }

      // Restore illustrations selection
      if (cartData.illustrations) {
        setSelectedIllustrations(cartData.illustrations);
        hasRestoredData = true;
      }

      // Transform cart API addon data to addons format
      let addonsPayload = null;
      if (cartData.item_details?.addon_items && Array.isArray(cartData.item_details.addon_items) && cartData.item_details.addon_items.length > 0) {
        const addonItemList = cartData.item_details.addon_items.map((addon) => ({
          design_id: addon.item__id,
          addon_name: addon.item_name,
          addon_arabic: addon.item__name_arabic,
          category: addon.category,
          unit_price: addon.unit_price?.toString() || String(addon.unit_price),
          unit_time: addon.unit_time?.toString() || String(addon.unit_time),
          qty: addon.qty?.toString() || String(addon.qty),
          item_type: addon.item_type || "addon",
          total_price: parseFloat(addon.subtotal_price || 0),
          language: addon.language || null,
          price_increment: addon.price_increment || 0,
        }));

        // Calculate total_price and total_time from addon items
        const totalPrice = addonItemList.reduce((sum, item) => sum + (item.total_price || 0), 0);
        const totalTime = Math.max(...addonItemList.map(item => parseInt(item.unit_time || 0)), 0);

        addonsPayload = {
          order_name: "Addons",
          total_price: totalPrice,
          total_time: totalTime,
          item_list: addonItemList,
        };

        setAddonPayLoads(addonsPayload);
        hasRestoredData = true;
      }

      // Restore extraQty from cart bundle_items if available
      if (cartData.item_details?.bundle_items && Array.isArray(cartData.item_details.bundle_items) && bundleDetails) {
        const flatList = bundleDetails.bundle_details?.flatMap(
          (item) => item.design_list
        );

        const restoredExtraQty = {};
        cartData.item_details.bundle_items.forEach((cartItem) => {
          const bundleDesign = flatList?.find(
            (design) => design.id === parseInt(cartItem.item__id)
          );

          if (bundleDesign) {
            const baseQuantity = bundleDesign.quantity || 1;
            const savedQuantity = parseInt(cartItem.qty) || 1;
            const extraQuantity = savedQuantity - baseQuantity;

            if (extraQuantity !== 0) {
              restoredExtraQty[bundleDesign.name_english] = extraQuantity;
            }
          }
        });

        if (Object.keys(restoredExtraQty).length > 0) {
          setExtraQty(restoredExtraQty);
          hasRestoredData = true;
        }
      }

      // Always save to localStorage (API is source of truth, update localStorage)
      // This ensures localStorage is always synced with API data
      if (hasRestoredData) {
        const payload = {
          order_name: cartData.project_name || brandInput,
          bundle_id: cartData.bundle_id,
          total_time: parseFloat(cartData.total_time || packageDetail?.package?.time || 0),
          total_price: parseFloat(cartData.total_amount || cartData.total_price || 0),
          item_list: cartData.item_details?.bundle_items?.map(item => ({
            design_id: item.item__id,
            unit_price: item.unit_price?.toString() || String(item.unit_price),
            unit_time: item.unit_time?.toString() || String(item.unit_time),
            qty: item.qty?.toString() || String(item.qty),
            item_type: item.item_type || "bundl",
          })) || [],
          addons: addonsPayload || {},
          order_status: "in_cart",
          language: cartData.language || selectedLanguage,
          illustrations: cartData.illustrations || selectedIllustrations,
        };
        localStorage.setItem("payloads", JSON.stringify(payload));
      }

      isLoadingFromStorage.current = false;
      return hasRestoredData;
    } catch (error) {
      console.error("Error loading data from cart API:", error);
      isLoadingFromStorage.current = false;
      return false;
    }
  };

  const loadDataFromLocalStorage = (bundleDetails) => {
    try {
      isLoadingFromStorage.current = true;
      const savedPayload = JSON.parse(localStorage.getItem("payloads") || "{}");

      if (!savedPayload || Object.keys(savedPayload).length === 0) {
        isLoadingFromStorage.current = false;
        return false; // Return false if no data to load
      }

      // Only load if bundle_id matches current package
      if (savedPayload.bundle_id && savedPayload.bundle_id !== routeId[packageID]) {
        isLoadingFromStorage.current = false;
        return false;
      }

      // Set isSameBundl to true so Accordian component will load addons from localStorage
      if (savedPayload.bundle_id === routeId[packageID]) {
        setIsSameBundl(true);
        hasLoadedFromStorage.current = true;
      }

      let hasRestoredData = false;

      // Restore brand input
      if (savedPayload.order_name) {
        setBrandInput(savedPayload.order_name);
        hasRestoredData = true;
      }

      // Restore language selection
      if (savedPayload.language) {
        // Capitalize language to match radio button values
        const capitalizedLanguage = savedPayload.language.charAt(0).toUpperCase() + savedPayload.language.slice(1).toLowerCase();
        setSelectedLanguage(capitalizedLanguage);
        hasRestoredData = true;
      }

      // Restore illustrations selection
      if (savedPayload.illustrations) {
        setSelectedIllustrations(savedPayload.illustrations);
        hasRestoredData = true;
      }

      // Restore addon payloads - but use a flag to prevent Accordian from overwriting during initial load
      if (savedPayload.addons && Object.keys(savedPayload.addons).length > 0) {
        // Temporarily set addonPayLoads, but Accordian will update it once it loads quantities from localStorage
        setAddonPayLoads(savedPayload.addons);
        hasRestoredData = true;
      }

      // Restore extraQty by comparing saved item_list with base quantities
      if (savedPayload.item_list && Array.isArray(savedPayload.item_list) && bundleDetails) {
        const flatList = bundleDetails.bundle_details?.flatMap(
          (item) => item.design_list
        );

        const restoredExtraQty = {};
        savedPayload.item_list.forEach((savedItem) => {
          // Find the corresponding design in bundle details by design_id
          const bundleDesign = flatList?.find(
            (design) => design.id === parseInt(savedItem.design_id)
          );

          if (bundleDesign) {
            const baseQuantity = bundleDesign.quantity || 1;
            const savedQuantity = parseInt(savedItem.qty) || 1;
            const extraQuantity = savedQuantity - baseQuantity;

            if (extraQuantity !== 0) {
              restoredExtraQty[bundleDesign.name_english] = extraQuantity;
            }
          }
        });

        if (Object.keys(restoredExtraQty).length > 0) {
          setExtraQty(restoredExtraQty);
          hasRestoredData = true;
        }
      }

      isLoadingFromStorage.current = false;
      return hasRestoredData;
    } catch (error) {
      console.error("Error loading data from localStorage:", error);
      isLoadingFromStorage.current = false;
      return false;
    }
  };

  const getBundlData = async () => {
    setLoading(true);
    const colors = {
      // '12':'#f175ad',
      // '4':'#1BA56F',
      // '22':"#00A8C8",
      // '13':'#f175ad',
      newbie: "#f175ad",
      foodie: "#1BA56F",
      socialite: "#00A8C8",
      boutiquer: "#f175ad",
    };

    // Check localStorage first for brand input (if not in state)
    if (!state || !("project_name" in state)) {
      try {
        const savedPayload = JSON.parse(localStorage.getItem("payloads") || "{}");
        if (savedPayload.order_name) {
          setBrandInput(savedPayload.order_name);
        }
      } catch (e) {
        console.error("Error loading brand input from localStorage:", e);
      }
    }

    if (state && "project_name" in state) {
      setBrandInput(state.project_name);
    }
    if (packageID == "newbie") {
      setCoinIcon(pinkIcon);
    } else if (packageID == "foodie") {
      setCoinIcon(greenIcon);
    } else if (packageID == "socialite") {
      setCoinIcon(blueIcon);
    } else if (packageID == "boutiquer") {
      setCoinIcon(pinkIcon);
    }
    setTextColor(colors[packageID]);
    const response = await axios.get(
      `${base_url}/api/package/?bundle_id=${routeId[packageID]}`
      // ConfigToken()
    );
    setBundlAddons(response?.data);
    setPackageDetail(response?.data);
    const flatList = response?.data?.bundle_details?.flatMap(
      (item) => item.design_list
    );

    const data = flatList?.reduce((acc, item) => {
      acc[item.name_english] = item.quantity;
      return acc;
    }, {});
    setQuantities(data);
    setactual(data);

    // Load saved data from localStorage after bundle data is loaded (for quick display)
    loadDataFromLocalStorage(response?.data);

    // Always try to load from cart API if user is logged in (API is source of truth)
    // This will update localStorage with fresh data from API
    let hasAPIData = false;
    const tokenConfig = ConfigToken();
    const isAuthenticated =
      tokenConfig.headers?.authorization &&
      tokenConfig.headers.authorization !== "Token null";

    if (isAuthenticated) {
      await loadDataFromCartAPI(response?.data);
    }

    setLoading(false);
  };
  const getprojects = async () => {
    const total_price =
      (parseFloat(packageDetail?.package?.price) || 0) +
      (addonPayLoads?.total_price ?? 0) +
      (selectedLanguage === "Both" ? 2000 : 0) +
      (selectedIllustrations === "illustrations" ? 2000 : 0);

    const applyNewbieMinOrderCheck = () => {
      if (packageID != "newbie") return true;
      const minNewbie = selectedIllustrations === "illustrations" ? 6880 : 4880;
      if (total_price < minNewbie) {
        toastErrorMessage(
          lang === "ar"
            ? (selectedIllustrations === "illustrations"
              ? "الحد الادنى لتصميم الهوية البصرية مع رسمات 6880 ريال"
              : "الأدنى للطلب يجب أن يكون 4,880")
            : (selectedIllustrations === "illustrations"
              ? "Minimum Order for brand identity with illustrations is 6880 SAR"
              : `Minimum order amount should be ${minNewbie}`)
        );
        return false;
      }
      return true;
    };

    const tokenConfig = ConfigToken();
    const isAuthenticated =
      tokenConfig.headers?.authorization &&
      tokenConfig.headers.authorization !== "Token null";

    // Unauthenticated users are by definition new clients (firstOrder stays true).
    // Apply the newbie min-order check locally and let createPayload's main flow
    // handle the redirect-to-login path — that path saves the cart payload to
    // localStorage before navigating, so the cart survives login.
    if (!isAuthenticated) {
      setFirstOrder(true);
      return applyNewbieMinOrderCheck();
    }

    try {
      const response = await axios.get(`${base_url}/api/order/`, ConfigToken());
      if (response.data) {
        const resProjects = response.data.data.filter(
          (item) => item.order_status != "in_cart"
        );
        // Set firstOrder based on whether user has previous orders
        if (resProjects.length === 0) {
          setFirstOrder(true);
        } else {
          setFirstOrder(false);
        }
        // Brand Identity min order validation only applies to new users
        if (packageID == "newbie") {
          let isNewUser = true; // default if profile fetch fails
          try {
            const profileRes = await axios.get(`${base_url}/api/profile/`, ConfigToken());
            if (profileRes?.data?.is_new_user === false) {
              isNewUser = false;
            }
          } catch (profileErr) {
            // Keep default isNewUser = true on error
          }
          if (isNewUser) {
            return applyNewbieMinOrderCheck();
          }
        }
      }
    } catch (e) {
      // Token is present but the server rejected it (expired/invalid) or the
      // request failed. Don't redirect from here — the subsequent
      // axios.get('/api/order/cart/') in createPayload will fail the same way
      // and its catch block builds + saves the cart payload to localStorage
      // before navigating to /login, preserving the user's cart.
      console.warn("getprojects failed; deferring auth handling to createPayload:", e);
    }
  };

  const colors = {
    newbie: "#f175ad",
    foodie: "#1BA56F",
    socialite: "#00A8C8",
    boutiquer: "#f175ad",
  };

  const [themeColor, setThemeColor] = useState("#000");

  useEffect(() => {
    const path = window.location.href.split("/")[4];
    if (colors[path]) {
      setThemeColor(colors[path]);
    }
  }, []);

  const toastMessage = () => {
    const message =
      lang === "ar" ? "تم تحديث السلة بنجاح." : "Cart updated successfully";

    if (newToastId) {
      toast.dismiss(newToastId);
    }

    newToastId = toast(message, {
      duration: 3000,
      style: {
        color: themeColor,
        border: `1px solid ${themeColor}`,
        fontWeight: "700",
        background: "#fff",
        boxShadow: "none",
        borderRadius: "0px",
      },
    });
  };

  const NewToastSuccMessage = (msg) => {
    const message = msg;

    if (newToastId) {
      toast.dismiss(newToastId);
    }

    newToastId = toast(message, {
      duration: 3000,
      style: {
        color: themeColor,
        border: `1px solid ${themeColor}`,
        fontWeight: "700",
        background: "#fff",
        boxShadow: "none",
        borderRadius: "0px",
      },
    });
  };

  const calculateAmount = (id, amount, payload) => {
    if (id === "1") {
      if (payload === "convertPayload") {
        return Number(amount) + 2000;
      } else {
        return amountDecimal(Number(amount) + 2000);
      }
    } else {
      const totalQty = Number(id) - 1;
      const cal = totalQty * ((Number(amount) + 2000) / 2); // 2000 / 2 = 1000
      if (payload === "convertPayload") {
        return cal + Number(amount) + 2000;
      } else {
        return amountDecimal(cal + Number(amount) + 2000);
      }
    }
  };

  const handleQuantityChange = (designName, change) => {
    const colors = {
      // '12':'#f175ad',
      // '4':'#1BA56F',
      // '22':"#00A8C8",
      // '13':'#f175ad',
      newbie: "#f175ad",
      foodie: "#1BA56F",
      socialite: "#00A8C8",
      boutiquer: "#f175ad",
    };

    if (designName in extraQty == false && change < 0) {
      setMinError([...minError, designName]);
      return;
    } else if (extraQty[designName] == 0 && change < 0) {
      setMinError([...minError, designName]);
      return;
    } else {
      setMinError((prevErrors) =>
        prevErrors.filter((error) => error !== designName)
      );
    }

    toastMessage();
    setExtraQty((prevQuantities) => {
      let newQuantity = (prevQuantities[designName] || 0) + change;
      return {
        ...prevQuantities,
        [designName]: newQuantity,
      };
    });
  };

  // Build payload and update localStorage immediately
  const updateLocalStorage = () => {
    // Skip if brand input is empty or bundle details not loaded
    if (!bundlAddons.bundle_details) {
      return;
    }

    try {
      // Build item_list with extraQty adjustments
      const item_list = bundlAddons.bundle_details.flatMap((bundle) =>
        bundle.design_list.map((design) => {
          const baseQuantity = quantities[design.name_english] || 1;
          const extraQuantity = extraQty[design.name_english] || 0;
          const finalQuantity = baseQuantity + extraQuantity;
          return {
            design_id: design.id,
            unit_price: design.price.toString(),
            unit_time: design.time.toString(),
            qty: finalQuantity.toString(),
            item_type: "bundl",
          };
        })
      );

      // Use current addonPayLoads - always use the latest state
      // BUT: If addonPayLoads is empty but we have saved addons in localStorage, preserve them
      // This prevents overwriting addons during initial load before Accordian has loaded them
      let addonsToProcess = {};
      const savedPayload = JSON.parse(localStorage.getItem("payloads") || "{}");
      const savedAddons = savedPayload?.addons || {};

      if (addonPayLoads && Object.keys(addonPayLoads).length > 0 && addonPayLoads.item_list?.length > 0) {
        // Current addonPayLoads has data, use it
        addonsToProcess = { ...addonPayLoads };
      } else if (savedAddons && Object.keys(savedAddons).length > 0 && savedAddons.item_list?.length > 0) {
        // Current addonPayLoads is empty but we have saved addons, preserve them
        // This happens during initial load when Accordian hasn't loaded quantities yet
        addonsToProcess = { ...savedAddons };
      } else {
        // No addons at all
        addonsToProcess = { item_list: [], total_price: 0, total_time: 0 };
      }

      // Process addons item_list with language adjustments
      const processedAddons = { ...addonsToProcess };
      if (processedAddons.item_list && Array.isArray(processedAddons.item_list)) {
        processedAddons.item_list = processedAddons.item_list.map((ele) => {
          if (
            ele.addon_name === "Logo & Identity" &&
            ele.category === "Branding" &&
            addOnLang.find((ele) => ele.id === 3)?.isChecked
          ) {
            return {
              ...ele,
              language: addOnLang.find((ele) => ele.isChecked).language,
              total_price: calculateAmount(
                ele.qty,
                ele.unit_price,
                "convertPayload"
              ),
            };
          } else {
            return ele;
          }
        });
      }

      // Build payload - use processedAddons for totals
      const addonTotalPrice = processedAddons?.total_price || 0;
      const addonTotalTime = processedAddons?.total_time || 0;

      const payload =
        isFromLogin && Object.keys(savedPayload).length
          ? {
              ...savedPayload,
              order_name: brandInput,
              total_time: (packageDetail?.package?.time || 0) + addonTotalTime,
              total_price:
                parseFloat(packageDetail?.package?.price || 0) +
                addonTotalPrice +
                (selectedLanguage === "Both" ? 2000 : 0) +
                (selectedIllustrations === "illustrations" ? 2000 : 0),
              item_list: item_list,
              addons: processedAddons,
              language: selectedLanguage,
              illustrations: selectedIllustrations,
            }
          : {
              order_name: brandInput,
              bundle_id: routeId[packageID],
              total_time: (packageDetail?.package?.time || 0) + addonTotalTime,
              total_price:
                parseFloat(packageDetail?.package?.price || 0) +
                addonTotalPrice +
                (selectedLanguage === "Both" ? 2000 : 0) +
                (selectedIllustrations === "illustrations" ? 2000 : 0),
              item_list: item_list,
              addons: processedAddons,
              order_status: "in_cart",
              language: selectedLanguage,
              illustrations: selectedIllustrations,
              isBackToBundl: state?.isBackToBundl,
            };

      // Always update localStorage immediately
      localStorage?.setItem("payloads", JSON.stringify(payload));
      return payload;
    } catch (error) {
      console.error("Error updating localStorage:", error);
      return null;
    }
  };

  const emptyCart = async () => {
    setOpenPopup(false);

    // Set flag to prevent useEffect hooks from updating localStorage
    isClearingCart.current = true;

    // Clear localStorage payloads
    localStorage.removeItem("payloads");

    // Reset states
    setExtraQty({});
    setAddonPayLoads({});
    hasLoadedFromStorage.current = false;
    setIsSameBundl(false);

    // Delete cart from API if authenticated
    const tokenConfig = ConfigToken();
    const isAuthenticated =
      tokenConfig.headers?.authorization &&
      tokenConfig.headers.authorization !== "Token null";

    if (isAuthenticated) {
      try {
        await axios.delete(`${base_url}/api/order/cart/`, ConfigToken());
      } catch (error) {
        console.error("Error deleting cart:", error);
        // Still proceed even if API call fails
      }
    }

    // Reset brand input
    setBrandInput("");

    // Reset flag after a short delay to allow state updates to complete
    setTimeout(() => {
      isClearingCart.current = false;
    }, 100);

    NewToastSuccMessage(
        lang === "ar"
            ? "تم إفراغ السلة بنجاح"
            : `Cart emptied successfully`
    );

    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const createPayload = async () => {
    if (isSubmitting.current) return;
    isSubmitting.current = true;
    try {
    if (brandInput?.trim() === "") {
      setBrandError(true);
      // Use setTimeout to ensure DOM has updated before scrolling
      setTimeout(() => {
        const element = document.getElementById('brandInput');
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth',
          });
          // Focus the input after scrolling
          element.focus();
        }
      }, 100);
      return;
    }

    const isValid = await validateFields();
    if (!isValid) {
      return;
    }

    if (!bundlAddons.bundle_details) {
      console.warn("No bundle details available yet.");
      return;
    }

    const item_list = bundlAddons.bundle_details.flatMap((bundle) =>
      bundle.design_list.map((design) => {
        const quantity = quantities[design.name_english] || 1;
        return {
          design_id: design.id,
          unit_price: design.price.toString(),
          unit_time: design.time.toString(),
          qty: quantity.toString(),
          item_type: "bundl",
        };
      })
    );

    const savedPayload = JSON.parse(localStorage.getItem("payloads") || "{}");
    const payload =
      isFromLogin && Object.keys(savedPayload).length
        ? savedPayload
        : {
            order_name: brandInput,
            bundle_id: routeId[packageID],
            total_time: (parseInt(packageDetail?.package?.time, 10) || 0) + (addonPayLoads?.total_time ?? 0),
            total_price:
              (parseFloat(packageDetail?.package?.price) || 0) +
              (addonPayLoads?.total_price ?? 0) +
              (selectedLanguage === "Both" ? 2000 : 0) +
              (selectedIllustrations === "illustrations" ? 2000 : 0),
            item_list: item_list,
            addons: addonPayLoads,
            order_status: "in_cart",
            language: selectedLanguage,
            illustrations: selectedIllustrations,
            isBackToBundl: state?.isBackToBundl,
          };

    try {
      const response = await axios.get(
        `${base_url}/api/order/cart/`,
        ConfigToken()
      );

      const isCartConflict =
        response?.data?.order_status &&
        !state?.project_name &&
        routeId[packageID] !== response.data.bundle_id;

      const isReLoginFlow =
        response?.data?.order_status && state?.project_name && state?.fromLogin;

      if (isCartConflict || isReLoginFlow) {
        setOpenPopup(true);
      } else {
        localStorage?.setItem("payloads", JSON.stringify(payload));
        const updatedItemList = payload.addons.item_list.map((ele) => {
          if (
            ele.addon_name === "Logo & Identity" &&
            ele.category === "Branding" &&
            addOnLang.find((ele) => ele.id === 3)?.isChecked
          ) {
            return {
              ...ele,
              language: addOnLang.find((ele) => ele.isChecked).language,
              total_price: calculateAmount(
                ele.qty,
                ele.unit_price,
                "convertPayload"
              ),
            };
          } else {
            return ele;
          }
        });

        payload.addons.item_list = updatedItemList;
        const createResponse = await axios.post(
          `${base_url}/api/order/create/`,
          payload,
          ConfigToken()
        );
        
        // Check for redirect_message in response
        const responseData = createResponse.data?.data?.data || createResponse.data?.data || createResponse.data;
        const redirectMessage = responseData?.redirect_message;
        const bundlEnglish = responseData?.bundl_english;
        
        // Check if Brand Identity order and new client
        const isBrandIdentity = packageID === "newbie";
        const isNewClient = firstOrder === true;
        
        // Only process redirect_message for Brand Identity orders from new clients
        if (redirectMessage && isBrandIdentity && isNewClient) {
          // Show toast message
          toast(redirectMessage, {
            duration: 4000,
            position: "bottom-right",
          });
          
          // Convert bundl_english to route name and redirect
          if (bundlEnglish) {
            const routeName = convertBundlEnglishToRoute(bundlEnglish);
            if (routeName) {
              navigate(`/bundldetail/${routeName}`, {
                state: { orderData: responseData, selectedLanguage, selectedIllustrations },
              });
              return;
            }
          }
          // If bundl_english is missing or invalid, fall back to mycart
          console.warn("redirect_message present but bundl_english is missing or invalid, redirecting to mycart");
        }
        
        navigate("/mycart", {
          state: { orderData: responseData, selectedLanguage, selectedIllustrations },
        });
      }
    } catch (error) {
      console.error("Error creating order:", error);
      localStorage?.setItem("payloads", JSON.stringify(payload));
      navigate(`/login?next_url=bundldetail/${packageID}`, {
        state: { project_name: brandInput },
      });
    }
    } finally {
      isSubmitting.current = false;
    }
  };

  useEffect(() => {
    if (user?.is_active) {
      const getcartData = async () => {
        const response = await axios.get(
          `${base_url}/api/order/cart/`,
          ConfigToken()
        );
        if (
          (lang === "ar"
            ? packageDetail?.package?.name_arabic
            : packageDetail?.package?.name_english) ===
          (lang === "ar"
            ? response?.data?.bundl_arabic
            : response?.data?.bundl_english)
        ) {
          setBrandInput(response?.data?.project_name);
          setIsSameBundl(true);
          hasLoadedFromStorage.current = true;
        } else {
          // Only reset isSameBundl if we haven't loaded from localStorage
          // This prevents clearing addons when navigating back from cart
          if (!hasLoadedFromStorage.current) {
            setIsSameBundl(false);
          }
        }
      };
      getcartData();
    }
  }, [user, lang, packageDetail]);

  useEffect(() => {
    const {
      headers: { authorization },
    } = ConfigToken();
    if (authorization !== "Token null") {
      const getcartData = async () => {
        const response = await axios.get(
          `${base_url}/api/order/cart/`,
          ConfigToken()
        );
        if (
          response.data.order_status === "in_cart" &&
          routeId[packageID] !== response?.data.bundle_id
        ) {
          setOpenPopup(response.data.order_status === "in_cart");
        } else {
          setOpenPopup(false);
        }
      };
      getcartData();
    }
  }, []);

  // Mark initial mount as complete after first render
  useEffect(() => {
    isInitialMount.current = false;
  }, []);


  // Update localStorage immediately when extraQty changes
  useEffect(() => {
    if (isInitialMount.current || isLoadingFromStorage.current || isClearingCart.current) {
      return;
    }
    updateLocalStorage(); // Update localStorage immediately
    // DON'T call API - only update on Proceed to Checkout
  }, [extraQty]);

  // Update localStorage immediately when addonPayLoads changes
  useEffect(() => {
    if (isInitialMount.current || isLoadingFromStorage.current || isClearingCart.current) {
      return;
    }
    // Only update if addonPayLoads actually has data (not empty)
    // This prevents overwriting saved addons during initial load
    if (addonPayLoads && Object.keys(addonPayLoads).length > 0 && addonPayLoads.item_list?.length > 0) {
      updateLocalStorage(); // Update localStorage immediately
      // DON'T call API - only update on Proceed to Checkout
    }
  }, [addonPayLoads]);

  // Update localStorage immediately when selectedLanguage changes
  useEffect(() => {
    if (isInitialMount.current || isLoadingFromStorage.current || isClearingCart.current) {
      return;
    }
    updateLocalStorage(); // Update localStorage immediately
    // DON'T call API - only update on Proceed to Checkout
  }, [selectedLanguage, selectedIllustrations]);

  // Update localStorage immediately when brandInput changes
  useEffect(() => {
    if (isInitialMount.current || isLoadingFromStorage.current || isClearingCart.current) {
      return;
    }
    if (brandInput?.trim() !== "") {
      updateLocalStorage(); // Update localStorage immediately
      // DON'T call API - only update on Proceed to Checkout
    }
  }, [brandInput]);

  let isSelectedLanguage = (selectedLanguage === "Both" ? 2000 : 0) + (selectedIllustrations === "illustrations" ? 2000 : 0);

  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 475);

  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth < 475);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
        <Toaster
            position="bottom-right"
            toastOptions={{
                style: {
                    color: themeColor,
                    fontWeight: "700",
                    border: `1px solid ${themeColor}`,
                    borderRadius: "0px !important",
                },
            }}
        />
      {loading ? (
        <Bgloader />
      ) : (
        <div>
          <Navbar isLang={lang} setIsLang={setLang} />
          <div className="bundl-detail mt-3">
            <div
              className="xs:px-2 sm:px-auto px-auto"
              style={{ borderBottom: "1.5px solid #000000", width: "100%" }}
            >
              <h2 className="sm:text-[38px] text-[38px] xs:text-[24px]">
                {lang === "ar"
                  ? packageDetail?.package?.name_arabic
                  : packageDetail?.package?.name_english || ""}
              </h2>
              <div className="bundl-amount">
                <p style={{ color: textColor }} className="flex items-center">
                  <img
                    src={coinIcon}
                    alt="Dollar icon"
                    className={`inline-block ${
                      lang === "ar" ? "ml-3" : "mr-3"
                    }`}
                  />
                  <span>
                    {" "}
                    <span className="mr-0 font-[400]">
                      {packageID === "newbie"
                        ? lang === "ar"
                          ? "تبدأ من​"
                          : "Starting from"
                        : ""}
                    </span>{" "}
                    {packageID === "newbie"
                      ? amountDecimal(4880)
                      : amountDecimal(
                          Math.round(packageDetail?.package?.price)
                        ) || `${amountDecimal(3750)} SAR`}{" "}
                    {lang === "ar" ? "ريال" : "SAR"}
                  </span>
                </p>
                <p style={{ color: textColor }} className="items-center flex">
                  <AccessTimeIcon
                    className={`${lang === "ar" ? "ml-1" : "mr-1"}`}
                  />
                  <span>
                    {" "}
                    {packageDetail?.package?.time || "30 Days"}{" "}
                    {lang === "ar" ? "يوما" : "Days"}
                  </span>
                </p>
              </div>
              <p className="bundl-desc" dangerouslySetInnerHTML={{__html: lang === "ar"
                  ? processArabicText(
                      packageDetail?.package?.description_arabic, true
                    )
                  : packageDetail?.package?.description_english || ""}}/>
              <p className="one-minor my-3">
                {lang === "ar"
                  ? "هذي الباقة تشمل تعديل مجاني واحد"
                  : "* This Bundl includes one minor revision"}
              </p>
            </div>

            <div className="bundl-section" style={{ position: "relative" }}>
              <div className="brand-details lg:!pt-16 md:!pt-[16] xs:!pt-8">
                <p
                  style={
                    window.innerWidth <= 441
                      ? lang === "ar"
                        ? {
                            fontSize: "18px",
                            fontWeight: "700",
                            lineHeight: "1.2",
                            textAlign: "right",
                          }
                        : {
                            fontSize: "18px",
                            fontWeight: "700",
                            lineHeight: "1.2",
                          }
                      : {
                          textAlign: lang === "ar" ? "right" : "left",
                          fontSize: "24px",
                          fontWeight: "700",
                        }
                  }
                >
                  {lang === "ar"
                    ? "ماهو اسم مشروعك؟​"
                    : "What is the name of your brand?"}
                </p>
                <input
                  id="brandInput"
                  className={`brand-input rounded-none ${
                    brandError && "!border-[#D83D99] rounded-none"
                  }`}
                  value={brandInput}
                  onChange={(e) => {
                    setBrandInput(e.target.value);
                    setBrandError(false);
                  }}
                />
                {brandError && (
                  <p className="text-[#D83D99]">
                    {lang === "ar"
                      ? "يرجى إدخال اسم المشروع"
                      : "Please enter name of the brand"}
                  </p>
                )}
                <div className="commerce-collateral">
                  {bundlAddons.bundle_details?.map((bundle, index) => {
                    return (
                      <div
                        key={index}
                        className="bundle-section"
                        // style={

                        //   window.innerWidth <= 475
                        //     ? { margin: "5% 0 0 0" }
                        //     : { margin: "3% 0 0 0" },
                        //     {cursor: "pointer"}
                        // }
                        style={{
                          margin:
                            window.innerWidth <= 475 ? "5% 0 0 0" : "3% 0 0 0",
                          cursor: "pointer",
                        }}
                      >
                        <p
                          className={`collateral-text mb-[2px] leading-[1.2] ${
                            lang === "ar" ? "text-right" : "text-left"
                          } ${
                            bundle.name_english === "Social Media Starter Kit"
                              ? "w-[80%]"
                              : "w-full"
                          }`}
                        >
                          {lang === "ar"
                            ? bundle.name_english === "Brand Identity"
                              ? "تصميم الهوية"
                              : bundle?.name_arabic
                            : bundle.name_english}
                        </p>
                        <p
                          className={`text-[16px] sm:text-[16px] xs:text-[16px] ${
                            lang === "ar" ? "text-right" : "text-left"
                          }`}
                          style={{ opacity: "50%" }}
                        >
                          {lang === "ar"
                            ? bundle.slogan_arabic
                            : bundle.slogan_english}
                        </p>
                        {bundle.name_english === "Brand Identity" ? (
                          <>
                          <div
                            className={`${
                              lang === "ar" ? "text-right" : "text-left"
                            }`}
                            style={
                              window.innerWidth < 441
                                ? {
                                    display: "flex",
                                    width: "100%",
                                    flexWrap: "wrap",
                                  }
                                : {
                                    display: "flex",
                                    width: "100%",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    flexWrap: "wrap",
                                  }
                            }
                          >
                            <p className="logo-design xs:basis-[100%] sm:basis-1/4">
                              {lang === "ar" ? "تصميم الشعار" : "Logo design"}
                            </p>
                            <p className="mr-3">
                              <label className="cursor-pointer flex items-center leading-none mb-0">
                                <input
                                  type="radio"
                                  name="language"
                                  value="English"
                                  className={`${
                                    lang === "ar" ? "ml-2" : "mr-2"
                                  }`}
                                  checked={selectedLanguage === "English"}
                                  onChange={handleRadioChange}
                                />
                                {lang === "ar" ? "انجليزي" : "English"}
                              </label>
                            </p>

                            <p className="mr-3">
                              <label className="cursor-pointer flex items-center leading-none mb-0">
                                <input
                                  type="radio"
                                  name="language"
                                  value="Arabic"
                                  className={`${
                                    lang === "ar" ? "ml-2" : "mr-2"
                                  }`}
                                  checked={selectedLanguage === "Arabic"}
                                  onChange={handleRadioChange}
                                />
                                {lang === "ar" ? "عربي" : "Arabic"}
                              </label>
                            </p>

                            <p
                              className={`${
                                lang === "ar" ? "mr-3" : "mr-[-0.6rem]"
                              }`}
                            >
                              <label className="cursor-pointer flex items-center leading-none mb-0">
                                <input
                                  type="radio"
                                  name="language"
                                  value="Both"
                                  className={`${
                                    lang === "ar" ? "ml-2" : "mr-2"
                                  }`}
                                  checked={selectedLanguage === "Both"}
                                  onChange={handleRadioChange}
                                />
                                {lang === "ar"
                                  ? `كلاهما (+٢٠٠٠  ريال)`
                                  : `Both (+${amountDecimal(2000)} SAR)`}
                              </label>
                            </p>
                          </div>
                          <div
                            className={`${
                              lang === "ar" ? "text-right" : "text-left"
                            }`}
                            style={
                              window.innerWidth < 441
                                ? {
                                    display: "flex",
                                    width: "100%",
                                    flexWrap: "wrap",
                                  }
                                : {
                                    display: "flex",
                                    width: "100%",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    flexWrap: "wrap",
                                  }
                            }
                          >
                            <p className="logo-design xs:basis-[100%] sm:basis-1/4">
                              {lang === "ar" ? "رسومات الهوية البصرية" : "Brand Illustrations"}
                            </p>

                            <p
                              className={`${
                                lang === "ar" ? "mr-3" : "mr-[-0.6rem]"
                              }`}
                            >
                              <label className="cursor-pointer flex items-center leading-none mb-0">
                                <input
                                  type="radio"
                                  name="illustrations"
                                  className={`${
                                    lang === "ar" ? "ml-2" : "mr-2"
                                  }`}
                                  checked={selectedIllustrations === "illustrations"}
                                  onClick={(e) => e.target.checked ? setSelectedIllustrations(""): null}
                                  onChange={(e) => setSelectedIllustrations(e.target.checked ? 'illustrations' : '')}
                                />
                                {lang === "ar"
                                  ? `مع رسومات الهوية (+٢٠٠٠  ريال)`
                                  : `With Illustrations (+${amountDecimal(2000)} SAR)`}
                              </label>
                            </p>
                          </div>
                          </>
                        ) : (
                          bundle.design_list.map((design, idx) => {
                            const isSingleItem =
                              bundle.design_list.length === 1;
                            const isLastIndex =
                              idx === bundle.design_list.length - 1;
                            const sectionClassName =
                              !isSingleItem && !isLastIndex
                                ? "commerce-sections"
                                : "commerce-sections1";
                            return (
                              <div
                                key={idx}
                                className={`flex flex-wrap justify-between pt-[2%] sm:pt-[2%] xs:pt-[5%] ${sectionClassName} w-[100%]`}
                              >
                                <p
                                  className={`sm:basis-[33%] basis-[33%] xs:basis-[66%] ${
                                    lang === "ar" ? "text-right" : "text-left"
                                  }`}
                                >
                                  {lang === "ar"
                                    ? processArabicText(design.name_arabic)
                                    : design.name_english}
                                </p>
                                {minError.includes(design.name_english) &&
                                  isMobile == false && (
                                    <div
                                      style={{ color: textColor }}
                                      className={`w-[47%] ${
                                        lang === "ar"
                                          ? "text-right"
                                          : "text-left"
                                      } text-[16px]`}
                                    >
                                      {lang === "ar"
                                        ? "لا يمكن تخفيض الحد الأدنى للكمية"
                                        : "Minimum quantity cannot be decreased"}
                                    </div>
                                  )}
                                <p
                                  className={` md:basis-auto basis-auto xs:basis-[10%] flex ${
                                    lang === "ar"
                                      ? "flex-row-reverse"
                                      : "flex-row"
                                  } items-center text-[#000000] h-[34px] border !border-[#000000]`}
                                >
                                  <button
                                    onClick={() =>
                                      handleQuantityChange(
                                        design.name_english,
                                        -1
                                      )
                                    }
                                    className={`${
                                      lang === "ar" ? "border-r" : "border-r"
                                    } !border-[#000000] px-1 flex h-[100%] items-center`}
                                  >
                                    <RemoveIcon />
                                  </button>
                                  <span
                                    className={`${
                                      lang === "ar" ? "border-r" : "border-r"
                                    } !text-[20px] font-normal px-2 !border-[#000000]`}
                                  >
                                    {" "}
                                    {parseInt(design.quantity) +
                                      (extraQty[design.name_english] || 0)}
                                  </span>
                                  <button
                                    onClick={() =>
                                      handleQuantityChange(
                                        design.name_english,
                                        1
                                      )
                                    }
                                    className="flex items-center px-1 "
                                  >
                                    <AddIcon />
                                  </button>
                                </p>
                                {minError.includes(design.name_english) &&
                                  isMobile && (
                                    <div
                                      style={{ color: textColor }}
                                      className={`w-[100%] ${
                                        lang === "ar"
                                          ? "text-right"
                                          : "text-left"
                                      } text-[16px]`}
                                    >
                                      {lang === "ar"
                                        ? "لا يمكن تخفيض الحد الأدنى للكمية"
                                        : "Minimum quantity cannot be decreased"}
                                    </div>
                                  )}
                              </div>
                            );
                          })
                        )}
                      </div>
                    );
                  })}
                </div>
                <Accordian
                  textColor={textColor}
                  extraQty={extraQty}
                  accordianTitle={
                    lang === "ar"
                      ? "مشروعك يحتاج إضافات؟"
                      : "Something feels missing ?"
                  }
                  addOnPayload={setAddonPayLoads}
                  handleAddOnChange={handleAddOnChange}
                  bundlePackageId={routeId[packageID]}
                  isLang={lang}
                  isSameBundl={isSameBundl}
                  addOnLang={addOnLang}
                  handleQuantityChange={handleQuantityChange}
                  TransitionProps={{
                    onEntered: () => {}, // override default behavior
                    timeout: 0, // disables animation if you want instant expand
                  }}
                  disableGutters
                />
              </div>
              {/* // border-black */}
              <div
  style={{
    ...(isMobile
      ? { border: "1px solid" }
      : {}),
  }}
  className={`
    border-r border-r-[rgba(0,0,0,0.1)]
    bundl-summary
    lg:overflow-visible md:overflow-visible
  `}
>
                  <div style={{
                      position: "sticky",
                      top: "0px",
                      alignSelf: "flex-start",
                      zIndex: 10,
                  }}>
                    <div style={isMobile ? {overflow: 'auto', maxHeight: '80vh'}: {}}>
                        {/* <div style={{borderRight: "1px solid #000000"}}></div> */}
                        <div className="bundl-name ">
                            <p
                                className={`sm:text-[24px] xs:mb-0 xs:justify-between sm:block font-[700] px-0 !mb-2 display: flex
 ${lang === "ar" ? "text-right" : "text-left"}`}
                            >
                    <span className="font-normal">
                      {lang === "ar" ? "ملخص الطلب​" : "Summary"}
                    </span>
                                {isMobile && (
                                    <button
                                        onClick={() => setDetails(!showDetails)}
                                        style={{ color: `${textColor}` }}
                                        className="text-[14px] font-normal underline uppercase"
                                    >
                                        {lang === "ar"
                                            ? showDetails
                                                ? "إخفاء التفاصيل"
                                                : "عرض التفاصيل"
                                            : showDetails
                                                ? "Hide Details"
                                                : "Show Details"}
                                    </button>
                                )}
                            </p>
                        </div>
                        {!isMobile || (isMobile && showDetails) ? (
                            <>
                                <div
                                    style={{ display: "flex", padding: "1% 2%" }}
                                    className="border-y-[1px] border-black"
                                >
                                    <p
                                        className={`sm:text-[20px] text-[20px] xs:text-[16px] font-[700] w-[60%] mb-0 pt-0 ${
                                            lang === "ar" ? "text-right" : "text-left"
                                        }`}
                                    >
                                        {lang === "ar"
                                            ? packageDetail?.package?.name_arabic
                                            : `${
                                                packageDetail?.package?.name_english || ""
                                            } Bundl`}
                                    </p>
                                    <p
                                        className={`sm:text-[20px] text-[20px] ${
                                            lang === "ar" ? "text-left" : "text-right"
                                        } xs:text-[16px] font-[700] w-[38%] mb-0 pt-0`}
                                    >
                                        {amountDecimal(
                                            Math.round(packageDetail?.package?.price)
                                        )}{" "}
                                        {lang === "ar" ? "ريال" : "SAR"}
                                    </p>
                                </div>

                                {bundlAddons?.bundle_details?.map((bundleItem, idx) => (
                                    <div
                                        key={bundleItem?.id}
                                        className={idx !== bundlAddons.bundle_details.length -1 ? "border-b-[1px] border-black": ""}
                                    >
                                        <p
                                            className={`text-black sm:text-[20px] text-[20px] xs:text-[16px] font-[700] !mb-1 w-full px-[2%] mt-[3%] ${
                                                lang === "ar" ? "text-right" : "text-left"
                                            }`}
                                        >
                                            {lang === "ar"
                                                ? bundleItem?.name_english === "Brand Identity"
                                                    ? "تصميم الهوية"
                                                    : bundleItem?.name_arabic
                                                : bundleItem?.name_english}
                                        </p>
                                        {bundleItem?.design_list?.map((item, idx) => {
                                            return (
                                                <div
                                                    key={idx}
                                                    className={`one-brand-identity xs:flex sm:block block flex-wrap justify-around`}
                                                >
                                                    <div className="flex xs:w-[100%]  w-full items-center justify-between">
                                                        <p
                                                            className={`text-black sm:text-[18px] text-[18px] xs:text-[16px] font-[400] !mb-1 xs:w-[75%] lg:w-full md:w-full mt-[3px] ${
                                                                lang === "ar" ? "text-right" : "text-left"
                                                            }`}
                                                        >
                                                            {item.quantity}{" "}
                                                            {lang === "ar"
                                                                ? item.name_arabic
                                                                : item.name_english}{" "}
                                                            <span className="sm:text-[16px] text-[16px] xs:text-[14px]">
                                    {item.id == "76" &&
                                        (selectedLanguage == "Both"
                                            ? "(English & Arabic)"
                                            : `(${selectedLanguage})`)}{" "}
                                  </span>
                                                            <span className="sm:text-[16px] text-[16px] xs:text-[14px]">
                                    {item.id == "76" &&
                                        (selectedIllustrations == "illustrations"
                                            ? "(Illustrations)"
                                            : ``)}
                                  </span>
                                                        </p>
                                                        {item.id == "76" &&
                                                        (selectedLanguage == "Both" || selectedIllustrations == "illustrations") ? (
                                                            <p
                                                                className={`sm:text-[18px] text-[18px] xs:text-[16px] font-[400] w-[50%] !mb-0 ${
                                                                    lang === "ar" ? "text-left" : "text-right"
                                                                }`}
                                                                style={{ color: textColor }}
                                                            >
                                                                +{" "}
                                                                {(() => {
                                                                    const languageIncrement = selectedLanguage == "Both" ? 2000 : 0;
                                                                    const illustrationIncrement = selectedIllustrations == "illustrations" ? 2000 : 0;
                                                                    const totalIncrement = languageIncrement + illustrationIncrement;
                                                                    return item.quantity == 1
                                                                        ? amountDecimal(
                                                                            parseFloat(item.price) + totalIncrement
                                                                        )
                                                                        : amountDecimal(
                                                                            parseFloat(item.price) +
                                                                            (parseFloat(item.price) / 100) *
                                                                            item.price_increment *
                                                                            (item.quantity - 1) +
                                                                            totalIncrement
                                                                        );
                                                                })()}{" "}
                                                                {lang === "ar" ? "ريال" : "SAR"}
                                                            </p>
                                                        ) : (
                                                            <p
                                                                className={`sm:text-[18px] text-[18px] xs:text-[16px] font-[400] lg:w-[40%] md:w-[50%] xs:w-[27%] !mb-0  ${
                                                                    lang === "ar" ? "text-left" : "text-right"
                                                                }`}
                                                                style={{ color: textColor }}
                                                            >
                                                                +{" "}
                                                                {item.quantity == 1
                                                                    ? amountDecimal(parseFloat(item.price))
                                                                    : amountDecimal(
                                                                        parseFloat(item.price) +
                                                                        (parseFloat(item.price) / 100) *
                                                                        item.price_increment *
                                                                        (item.quantity - 1)
                                                                    )}{" "}
                                                                {lang === "ar" ? "ريال" : "SAR"}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ))}

                                <div>
                                    {addonPayLoads?.item_list?.length > 0 && (
                                        <p
                                            className={`lg:text-[20px] md:text-[20px] xs:text-[16px] mb-0 font-[700]  border-b-[1px] border-black px-[2%] py-[1%] ${
                                                lang === "ar" ? "text-right" : "text-left"
                                            }`}
                                        >
                                            {lang === "ar" ? "إضافات" : "Add ons"}
                                        </p>
                                    )}
                                </div>

                                {addonPayLoads?.item_list &&
                                    Object.entries(
                                        addonPayLoads.item_list.reduce((acc, addon) => {
                                            acc[addon.category] = acc[addon.category] || [];
                                            acc[addon.category].push(addon);
                                            return acc;
                                        }, {})
                                    ).map(([category, addons]) => (
                                        <div key={category}>
                                            <p
                                                className={`text-black sm:text-[20px] text-[20px] xs:text-[16px] font-[700] !mb-1 w-full px-[2%] mt-[3%] ${
                                                    lang === "ar" ? "text-right" : "text-left"
                                                }`}
                                            >
                                                {category}
                                            </p>
                                            {addons.map((addon, idx) => {
                                                return (
                                                    <div
                                                        key={idx}
                                                        // className={`sm:block block flex-wrap justify-around ${
                                                        //   idx !== addons.length - 1
                                                        //     ? "h-[25px]"
                                                        //     : "border-b-[1px] border-black"
                                                        // } ${
                                                        //   addon.category === "Branding" &&
                                                        //   addon.addon_name === "Logo & Identity"
                                                        //     ? "mb-8" // or use inline style for spacing
                                                        //     : ""
                                                        // }
                                                        // ${
                                                        //   addon.category === "Branding" &&
                                                        //   addon.addon_name === "Logo Translation"
                                                        //     ? "mt-8" // or use inline style for spacing
                                                        //     : ""
                                                        // }

                                                        // `}

                                                        className={`sm:block block flex-wrap justify-around`}
                                                    >
                                                        <div
                                                            style={
                                                                isMobileView
                                                                    ? {
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "space-between",
                                                                    }
                                                                    : {}
                                                            }
                                                        >
                                                            <div
                                                                className={`flex mx-4 w-full sm:w-auto ${
                                                                    addon.category === "Branding" &&
                                                                    addon.addon_name === "Logo & Identity"
                                                                        ? ""
                                                                        : ""
                                                                }`}
                                                                style={
                                                                    {
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "space-between",
                                                                    }
                                                                }
                                                            >
                                                                <p
                                                                    className={`text-black sm:text-[18px] text-[18px] 
                                      xs:text-[16px] font-[400] !mb-1 ${
                                                                        window.innerWidth <= 475
                                                                            ? "lg:w-[50%]"
                                                                            : "lg:w-[50%]"
                                                                    } md:w-[50%] sm:w-full ${
                                                                        lang === "ar"
                                                                            ? "text-right"
                                                                            : "text-left"
                                                                    }`}
                                                                    style={
                                                                        isMobileView
                                                                            ? { marginBottom: "0px" }
                                                                            : {}
                                                                    }
                                                                >
                                                                    {addon.qty}{" "}
                                                                    {/* {lang === "ar" ? (
                                        addon.addon_arabic
                                      ) : addon.addon_name ===
                                        "Logo & Identity" ? (
                                        <span>
                                          {addon.addon_name}(
                                          {addOnLang.find(
                                            (ele) => ele.isChecked
                                          )?.language === "both"
                                            ? "English & Arabic"
                                            : addOnLang.find(
                                                (ele) => ele.isChecked
                                              )?.language}
                                          )
                                        </span>
                                      ) : (
                                        addon.addon_name
                                      )} */}
                                                                    <span>
                                        {lang === "ar"
                                            ? addon.addon_arabic
                                            : addon.addon_name}
                                      </span>
                                                                </p>
                                                                <p
                                                                    // className={`sm:text-[18px] text-[18px] xs:text-[16px] font-[400] lg:w-[40%] md:w-[50%]  md:pr-[44px] xs:w-[25%] ${
                                                                    className={`sm:text-[18px] text-[18px] xs:text-[16px] font-[400] lg:w-[40%] ${
                                                                        lang === "ar"
                                                                            ? "text-left"
                                                                            : "text-right"
                                                                    }`}
                                                                    style={{
                                                                        ...(isMobile
                                                                            ? { marginBottom: "0px" }
                                                                            : {}),
                                                                        color: textColor,
                                                                    }}
                                                                >
                                                                    +{" "}
                                                                    {addOnLang.find((ele) => ele.isChecked)
                                                                        ?.language === "both"
                                                                        ? calculateAmount(
                                                                            addon.qty,
                                                                            addon.unit_price,
                                                                            ""
                                                                        )
                                                                        : amountDecimal(addon.total_price)}{" "}
                                                                    {lang === "ar" ? "ريال" : "SAR"}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ))}
                            </>
                        ) : (
                            ""
                        )}

                        <div className="bundl-checkout sticky bottom-0 bg-white border-t border-t-black sm:mt-3">
                            <div
                                className="total !font-[700]"
                                style={{ display: "flex" }}
                            >
                                <p
                                    className="sm:mb-3 xs:mb-0 flex items-center !xs:text-[16px] !sm:text-[20px]"
                                    style={{ width: "60%" }}
                                >
                                    <img
                                        src={BlackDollor}
                                        alt="Total Price"
                                        className="inline-block !font-[700] sm:ml-1 xs:ml-2"
                                    />
                                    <span
                                        className={`${
                                            lang === "ar" ? "mr-3" : "sm:ml-3 xs:ml-5"
                                        } !font-[700]`}
                                    >
                        {lang === "ar" ? "السعر الإجمالي :" : "Total Price :"}
                      </span>
                                </p>
                                <p
                                    className={`!font-[700] ${
                                        lang === "ar" ? "text-start" : "text-end"
                                    } !xs:text-[16px] !sm:text-[20px] sm:mb-3 xs:mb-0`}
                                    style={{ width: "40%" }}
                                >
                                    {/* {amountDecimal(
                        parseFloat(
                          Number(packageDetail?.package?.price) +
                            Number(addonPayLoads?.total_price) + isSelectedLanguage && 2000
                        )
                      ) } */}
                                    {amountDecimal(
                                        (Number(packageDetail?.package?.price) || 0) +
                                        (Number(addonPayLoads?.total_price) || 0) +
                                        (isSelectedLanguage || 0)
                                    ) || 0}
                                    {/* // (selectedLanguage === "Both"
                        //   ? amountDecimal(2000)
                        //   : "")} */}
                                    {/* {lang === "ar" ? "ريال" : "SAR"} */}
                                    {lang === "ar"
                                        ? "\u00A0\u00A0\u00A0ريال"
                                        : "\u00A0\u00A0\u00A0SAR"}
                                </p>
                            </div>
                            <div className="total" style={{ display: "flex" }}>
                                <p
                                    className="!xs:text-[16px] flex items-center !sm:text-[20px]"
                                    style={{ width: "60%" }}
                                >
                                    <img
                                        src={BlackTime}
                                        alt="Total Duration"
                                        className={`inline-block ${
                                            lang === "ar" ? "mr-[-5px]" : ""
                                        }`}
                                    />
                                    <span
                                        className={`${
                                            lang === "ar"
                                                ? "mr-2 xs:mr-3.5"
                                                : "xs:ml-4 sm:ml-1 ml-1"
                                        }`}
                                    >
                        {lang === "ar"
                            ? "المدة الإجمالية :"
                            : "Total Duration :"}
                      </span>
                                </p>
                                <p
                                    className={`!xs:text-[16px] ${
                                        lang === "ar" ? "text-start" : "text-end"
                                    } !sm:text-[20px]`}
                                    style={{ width: "40%" }}
                                >
                                    {(parseInt(packageDetail?.package?.time, 10) || 0) + (Number(addonPayLoads?.total_time) || 0)}
                                    {/* {lang === "ar" ? "يوما" : "Days"} */}
                                    {lang === "ar"
                                        ? "\u00A0\u00A0\u00A0\u00A0يوم"
                                        : "\u00A0\u00A0Days"}
                                </p>
                            </div>

                            <div className="flex justify-center items-center">
                                {(parseFloat(packageDetail?.package?.price) || 0) +
                                (addonPayLoads?.total_price ?? 0) >
                                700 ? (
                                    <div className="flex flex-col gap-[2%]">
                                        <button
                                            style={{ backgroundColor: textColor }}
                                            className={`proceed uppercase !bg-[${textColor}] mt-[3%]`}
                                            onClick={createPayload}
                                        >
                                            {lang === "ar"
                                                ? "الذهاب إلى السلة"
                                                : "Proceed to Checkout"}
                                        </button>

                                        <button
                                            style={{ backgroundColor: textColor }}
                                            className={`proceed uppercase !bg-[${textColor}] mt-[3%]`}
                                            onClick={() => {
                                                emptyCart();
                                            }}
                                        >
                                            {lang === "ar" ? "إفراغ السلة" : "Empty Cart"}
                                        </button>
                                    </div>
                                ) : (
                                    <button
                                        style={{ backgroundColor: textColor }}
                                        className={`proceed uppercase !bg-[${textColor}]`}
                                        disabled
                                    >
                                        {lang === "ar" ? "المتابعة إلى السلة​" : "Proceed cart"}
                                    </button>
                                )}
                            </div>
                            {/* {(firstOrder && packageID == 'newbie') && <p className='proceed-text'>{lang === 'ar' ? 'يجب أن يكون الحد الأدنى للمجموع أكثر من 700 ريال سعودي' : 'Your minimum total should be above 4880 SAR'}</p>} */}
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
          {window?.innerWidth >= 500 && <Footer isLang={lang} />}
        </div>
      )}
      {openPopup && (
        <Popup
          openpopup={openPopup}
          setPopup={setOpenPopup}
          title={""}
          subTitle={
            lang === "ar"
              ? "لديك عناصر في سلة التسوق. هل ترغب في"
              : "You already have items in your cart. Would you like to."
          }
          onClick={emptyCart}
          save={lang === "ar" ? "الاستمرار" : "Continue"}
          cancel={lang === "ar" ? "الإلغاء" : "Cancel"}
          cancelClick={setIsFromLogin}
          isLang={lang}
        />
      )}
    </>
  );
};
